import { useMemo } from 'react';

import { COLORS, STYLES } from 'apps/web_forms/utils/constants';

const useSelectStyles = ({ isValid, hasResourceUpdateHighlight }) => {
  const errorStyles = useMemo(() => {
    if (!isValid) {
      return {
        neutral20: COLORS.red,
        neutral10: COLORS.red,
        neutral30: COLORS.red,
      };
    }
    return {};
  }, [isValid]);

  const customStyles = useMemo(() => {
    return {
      dropdownIndicator: () => ({
        color: COLORS.green,
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 3,
      }),
      option: (provided) => ({
        ...provided,
        fontSize: '0.8em',
      }),
      control: (provided) => ({
        ...provided,
        fontSize: '0.8em',
        borderWidth: hasResourceUpdateHighlight
          ? STYLES.UpdateHighlightBorderWidth
          : provided.borderWidth,
        borderColor: getBorderColor(provided, hasResourceUpdateHighlight),
        '&:hover': {
          borderColor: getBorderColor(provided, hasResourceUpdateHighlight),
        },
      }),
    };
  }, [hasResourceUpdateHighlight]);

  return {
    errorStyles,
    customStyles,
  };
};

const getBorderColor = (provided, hasResourceUpdateHighlight) =>
  hasResourceUpdateHighlight ? COLORS.yellow : provided.borderColor;

export default useSelectStyles;
